/**
 * @fileoverview GET handler for the "/companies/:company_id/oauth_mcp_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdOauthMcpSettings } from "./constants";
import type { GetCompaniesCompanyIdOauthMcpSettingsResult } from "./types";
import { isGetCompaniesCompanyIdOauthMcpSettingsResult } from "./validators";

export const getCompaniesCompanyIdOauthMcpSettings = reactQueryFetcherAdapter(
  companiesCompanyIdOauthMcpSettings,
  (signal: AbortSignal, companyId: string): Promise<GetCompaniesCompanyIdOauthMcpSettingsResult> => {
    return fetch(`/companies/${companyId}/oauth_mcp_settings`, "GET", {}, { signal });
  },
  isGetCompaniesCompanyIdOauthMcpSettingsResult
);
